import { Link } from 'react-router-dom';
import strategyArrow from '../../../assets/icons/check-in/strategy-arrow.svg';

interface StrategyCardProps {
  id: string;
  title: string;
  subtitle: string;
  iconImageUrl: string | null;
  category?: string;
  subEmotionParam?: string;
}

export default function StrategyCard({ id, title, subtitle, iconImageUrl, category, subEmotionParam }: StrategyCardProps) {
  const query = new URLSearchParams();
  if (category) query.set('category', category);
  if (subEmotionParam) query.set('sub', subEmotionParam);
  const queryString = query.toString();

  return (
    <Link
      to={`/check-in/strategies/${id}${queryString ? `?${queryString}` : ''}`}
      className="flex items-center gap-4 min-[414px]:gap-6 bg-white rounded-[48px] p-2 hover:shadow-sm transition-shadow"
    >
      {/* Icon container */}
      <div className="w-[60px] h-[60px] min-[414px]:w-20 min-[414px]:h-20 rounded-full bg-[#C7EDEF] flex-shrink-0 flex items-center justify-center overflow-hidden">
        {iconImageUrl ? (
          <img src={iconImageUrl} alt="" className="w-10 h-10 min-[414px]:w-12 min-[414px]:h-12 object-contain" />
        ) : (
          <div className="w-10 h-10 min-[414px]:w-12 min-[414px]:h-12 rounded-full bg-[#C7EDEF]" />
        )}
      </div>

      {/* Text block */}
      <div className="flex-1 min-w-0 flex flex-col gap-2">
        <h3
          className="text-lg font-bold text-[#1B2831] truncate"
          style={{ fontFamily: 'DM Sans', letterSpacing: '-0.72px' }}
        >
          {title}
        </h3>
        <p
          className="text-sm text-[#323B46] truncate"
          style={{ fontFamily: 'DM Sans' }}
        >
          {subtitle}
        </p>
      </div>

      {/* Forward arrow */}
      <div className="w-10 h-10 min-[414px]:w-16 min-[414px]:h-16 flex items-center justify-center flex-shrink-0">
        <img src={strategyArrow} alt="" width={24} height={24} />
      </div>
    </Link>
  );
}
